import { render, staticRenderFns } from "./dict-form.vue?vue&type=template&id=dcf6df30&scoped=true&"
import script from "./dict-form.vue?vue&type=script&lang=ts&"
export * from "./dict-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf6df30",
  null
  
)

export default component.exports